import { render, staticRenderFns } from "./StatsRow.vue?vue&type=template&id=5b7f33e0&lang=pug&"
import script from "./StatsRow.vue?vue&type=script&lang=js&"
export * from "./StatsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports